document.addEventListener('DOMContentLoaded', function (e) {
	const mainNav = document.querySelector('.m-navigation__drawer-js');

	if (mainNav) {
		const parentLinks = mainNav.querySelectorAll('.menu-item--expanded');
		const menuButton = document.querySelector('.a-menu__reveal');
		const pageCover = document.querySelector('.a-page__cover');
		const body = document.querySelector('body');
		const offCanvas = document.querySelector('.dialog-off-canvas-main-canvas');

		const revealMenu = function (button, menu) {
			let hamburger = button.querySelector('.a-icon__menu');
			let mainBody = document.querySelector('.layout-container');

			if (hamburger.classList.contains('a-icon__menu--close')) {
				hamburger.classList.remove('a-icon__menu--close');
				mainBody.classList.remove('menu-reveal');
				menu.removeAttribute('style');
				body.style.overflowY = 'auto';
				offCanvas.removeAttribute('style');
			} else {
				hamburger.classList.add('a-icon__menu--close');
				mainBody.classList.add('menu-reveal');
				menu.style.zIndex = '9999';
				body.style.overflowY = 'hidden';
				//offCanvas.style.overflowY = 'hidden';
				//offCanvas.style.height = '100vh';
			}
		};

		const expandChildList = function (link) {
			if (!link.classList.contains('open')) {
				link.classList.add('open');
				link.setAttribute('aria-expanded', 'true');
			} else {
				link.classList.remove('open');
				link.setAttribute('aria-expanded', 'false');
			}
			
			let linkSiblings = link.parentElement.childNodes;
			linkSiblings.forEach(sibling => {
				if (link !== sibling && sibling.classList) {
					if (sibling.classList.contains('open')) {
						sibling.classList.remove('open');
						sibling.querySelector('.m-menu--inner').removeAttribute('style');
					}
				}
			});

			let childMenu = link.querySelector('.m-menu--inner');
			if (childMenu.offsetHeight > 2) {
				childMenu.removeAttribute('style');
			} else {
				childMenu.style.height = childMenu.scrollHeight + 36 + 'px';
			}
			return false;
		};

		pageCover.addEventListener('click', function (e) {
			revealMenu(menuButton, mainNav);
		});

		menuButton.addEventListener('click', function (e) {
			revealMenu(menuButton, mainNav);
		});

		parentLinks.forEach(function (link) {
			let span = link.querySelector('span');
			span.addEventListener('click', function (e) {
				e.preventDefault();
				expandChildList(link);
			});
			span.addEventListener('keydown', function (e) {
				if (e.code === 13) {
					e.preventDefault();
					expandChildList(link);
				}
			});
		});
	}
});
